module.exports = __webpack_public_path__ + "images/emoji/city_sunrise.8f075ab30d9bc62698d2.png";